import { gql } from '@apollo/client';
const UPDATE_PRODUCT_MAIN_CATEGORY = gql `
  mutation UpdateProductMainCategory(
    $productMainCategoryId: ID!
    $name: String!
    $description: String
    $thumbnail: String
  ) {
    updateProductMainCategory(
      productMainCategoryId: $productMainCategoryId
      name: $name
      description: $description
      thumbnail: $thumbnail
    ) {
      productMainCategory {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default UPDATE_PRODUCT_MAIN_CATEGORY;
